import OptimizedImage from "@/components/OptimizedImage";
import { Button } from "@/components/ui/button";

/**
 * Static hero component for Metronome → House Beat rebrand
 */
const HeroStatic = () => {
  return (
    <section className="relative w-full bg-white pt-24 pb-8 md:pt-32 md:pb-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Column - Content */}
          <div className="space-y-6">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground leading-tight">
              Metronome is now{" "}
              <span className="block">House Beat<span style={{ color: '#62e28d' }}>.</span></span>
            </h1>
            
            {/* House Beat Logo */}
            <div className="py-2">
              <img 
                src="/housebeat_logo.svg" 
                alt="House Beat logo" 
                className="h-12 sm:h-14"
              />
            </div>
            
            <p className="text-xl sm:text-2xl font-semibold text-foreground">
              Same mission. New name. A stronger platform for homeowners.
            </p>
            
            <p className="text-lg text-gray-600 leading-relaxed font-bold">
              We've evolved Metronome into House Beat, with a new look, clearer focus, and meaningful upgrades designed to help you stay organized, avoid surprises, and take better care of your home.
            </p>
            
            <a 
              href="https://housebeat.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="mt-4 inline-block"
              aria-label="Go to House Beat website"
            >
              <Button size="lg" className="min-h-[56px] px-12 py-4 text-lg font-bold">
                Go to housebeat.com
              </Button>
            </a>
          </div>
          
          {/* Right Column - Image */}
          <div className="relative w-full h-[320px] sm:h-[400px] lg:h-[480px] rounded-2xl overflow-hidden shadow-2xl">
            <OptimizedImage 
              src="/hero_homepage.jpg"
              alt="Family with young children standing in front of their home"
              className="w-full h-full object-cover"
              width={1200}
              height={800}
              context="hero"
              quality={60}
              fetchPriority="high"
              noPlaceholder={true}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroStatic;
